import { render, staticRenderFns } from "./zhongShanQuestionnaireDetail.vue?vue&type=template&id=4788ab7d&scoped=true"
import script from "./zhongShanQuestionnaireDetail.vue?vue&type=script&lang=js"
export * from "./zhongShanQuestionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./zhongShanQuestionnaireDetail.vue?vue&type=style&index=0&id=4788ab7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788ab7d",
  null
  
)

export default component.exports